import { Group, Image, List, ListItem, Stack, Text, Title } from '@mantine/core'
import clsx from 'clsx'
import { useParams } from '@tanstack/react-router'
import { TwContainer } from '@/lib/components/TwContainer'

export const AboutUs = ({
	title,
	items,
	body,
	bodyClassName,
	subTitle,
}: {
	title?: string
	items?: Array<string>
	body?: string
	bodyClassName?: string
	subTitle?: string
}) => {
	const { location } = useParams({ strict: false })
	if (!items) {
		items = [
			'Fast and accurate rapid tests and labs for HIV, HCV, and common STIs/ STDs.',
			'Tailored education, resources, and counseling with actionable takeaways.',
			'Done-for-you anonymous notifications to recent contacts.',
			'HIV prevention options including PrEP and PEP.',
			'Answers to your most pressing questions from our experienced medical staff.',
			'And more',
		]
	}
	return (
		<section id={'about'}>
			<TwContainer md className={'justify-center py-24 gap-12'} column>
				<Group gap={'xl'} align={'center'} justify={'space-around'}>
					<Image
						loading={'lazy'}
						className={'md:max-w-sm max-w-xs rounded-[32px]'}
						src={'/images/img_11.webp'}
						w={380}
						h={380}
						alt={'Wellview Care'}
					/>
					<Stack className={clsx('max-w-lg p-8', bodyClassName)} gap={'xs'}>
						<Title variant={'cyan'} fz={18}>
							ABOUT US
						</Title>
						<Title variant={'title2'}>{title || 'About Wellview Care'}</Title>
						<Text fs={'lg'} component={'div'} className={'flex flex-col'} variant={'gray'} ta={'left'}>
							{body || (
								<>
									With service to{' '}
									{location === 'Fort-Lauderdale' ? 'Fort Lauderdale' : location === 'Riviera-Beach' ? 'Riviera Beach' : 'Southeast Florida'}, our
									Wellview Care team makes quality care accessible regardless of insurance status. We believe in empowering those we serve to thrive.
								</>
							)}
							<strong className={'pt-6 pb-2'}>{subTitle || 'Core Offerings:'}</strong>
							<List size={'md'}>
								{items.map((item, index) => (
									<ListItem key={index}>{item}</ListItem>
								))}
							</List>
						</Text>
					</Stack>
				</Group>
			</TwContainer>
		</section>
	)
}
